export const TicketDistanceTypes = {
  Regular: "Regular",
  Classic: "Classic",
  MiniTrip: "MiniTrip",
} as const;

export type TicketDistanceType =
  (typeof TicketDistanceTypes)[keyof typeof TicketDistanceTypes];
